import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";

const programConfigs = degreesConfig.programs.unc;

export const unc = {
  slug: "unc",
  name: "University of North Carolina",
  colors: {
    primary1: "#1576d4",
    primary2: "#00262b",
    primary3: "#fecf48",
    primary4: "#d23228",
    text: "#000",
  },
  fonts: {
    url: "https://whitelabel.2u.com/cdn/v1/5892510e-ec69-4623-bea0-42af7b368d45/marketing/whitelabel.fonts.min.css?ver=1.0",
    base: "Franklin Gothic URW, sans-serif",
  },
  programConfigs,
};
